import React, { Component } from "react";
import { Select, MenuItem } from "@mui/material";
import { TiersApi } from "../../services/api/api";
import { toast } from "react-toastify";

class TierDropdown extends Component {
  _isMounted = false;

  state = {
    tiers: [],
    isLoading: true,
    t: [],
    default: 0,
    newDefault: this.props.defaultValue,
    disabled: true,
    size: this.props.size,
    initResponse: this.props.initResponse,
    tierData: this.props.tierData,
    extraData: this.props.extraData,
    customId: this.props.customId,
    excludeId: this.props.excludeId || null,
  };

  componentDidMount() {
    this._isMounted = true;

    if (!this.state.tierData) {
      if (localStorage.getItem("tierDropdownList")) {
        this.setState({
          tiers: JSON.parse(localStorage.getItem("tierDropdownList")),
          t: JSON.parse(localStorage.getItem("tierDropdownzList")),
          disabled: false,
        });
      }

      this.getTierListEndpoint();
    } else this.useLocalData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.setState({ default: this.props.defaultValue });
    }
  }

  useLocalData() {
    let list = this.state.tierData;

    list.forEach((item) => {
      item.tier = item.nickname;
    });

    let ztier = [];

    list.forEach((item) => {
      ztier[item.relId] = item;
    });

    if (this._isMounted) {
      this.setState({
        tiers: list,
        t: ztier,
        disabled: false,
      });

      if (this.state.newDefault) {
        this.setState({ default: this.state.newDefault });
      }
      //console.log("Value", this.state.default);

      if (this.state.initResponse) {
        //console.log(this.state.t);
        this.state.initResponse(
          ztier[Number(this.state.newDefault)].color,
          ztier[Number(this.state.newDefault)].relId,
          ztier[Number(this.state.newDefault)].nickname
        );
      }
    }
  }

  getTierListEndpoint = async () => {
    if (this._isMounted) {
      try {
        const result = await TiersApi.getTiers(this.props.token);
        
        if (result.success) {
          const excludeId = this.props.excludeId;
          let tiers = [];
          // Add fetched tiers, omitting any excluded id
          result.data.forEach((item) => {
            if (item.relId !== excludeId) {
              tiers.push({ relId: item.relId, tier: item.tierName, color: item.color });
            }
          });
          // Build mapping from relId to tier object
          const t = [];
          tiers.forEach((tier) => {
            t[tier.relId] = tier;
          });
          // Set selected default to props.defaultValue, including 0
          this.setState({ tiers, t, default: this.props.defaultValue || 0, disabled: false });
        } else {
          console.error("Failed to fetch tiers:", result.message);
          toast.error(`Failed to load tiers: ${result.message}`);
        }
      } catch (error) {
        console.error("Error fetching tiers", error);
      }
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  setTierData = (e) => {
    const color = this.state.t[e.target.value].color;
    const id = this.state.t[e.target.value].relId;
    const name = this.state.t[e.target.value].tier;
    const tierId = this.state.t[e.target.value].relId; // Fixed: was .id, should be .relId
    const parentTier = this.state.t[e.target.value].parentTier;

    if (this.state.extraData !== null) {
      this.props.action(
        color,
        id,
        name,
        tierId,
        this.state.extraData,
        parentTier
      );
    } else this.props.action(color, id, name, tierId);

    if (this._isMounted) this.setState({ default: id });

    if (this.props.followUp) this.props.followUp();
  };

  render() {
    const { customId, disabled, tiers } = this.state;
    const defaultValue = Number(this.state.default);
    // Ensure value is not null and exists in the tiers list, otherwise, Select will be uncontrolled.
    const value =
      tiers.find((t) => t.relId === defaultValue) !== undefined
        ? defaultValue
        : "";

    const sxProps = !customId
      ? { display: "inline-flex", width: "auto" }
      : {};

    return (
      <Select
        id={customId}
        onChange={this.setTierData}
        required
        disabled={disabled}
        value={value}
        size={this.state.size === "sm" ? "small" : "medium"}
        sx={sxProps}
      >
        {tiers.map((i, index) => (
          <MenuItem value={i.relId} key={index}>
            {i.tier}
          </MenuItem>
        ))}
      </Select>
    );
  }
}

export default TierDropdown;
